import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import useMobileSearchModal from '../../hooks/useMobileSearchModal';

export default ({ opened, children }) => {
  const modalRoot = document.getElementById('zoom-wrapper') || document.getElementById('root');
  const isMobileModal = useMobileSearchModal();

  const body = document.querySelector('body');
  const html = document.querySelector('html');

  useEffect(() => {
    if (!isMobileModal) {
      return;
    }

    if (opened) {
      body.classList.add('search-modal-is-open');
      html.classList.add('search-modal-is-open');
    } else {
      body.classList.remove('search-modal-is-open');
      html.classList.remove('search-modal-is-open');
    }
    return () => {
      body.classList.remove('search-modal-is-open');
      html.classList.remove('search-modal-is-open');
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [opened, isMobileModal]);

  if (isMobileModal) {
    return !opened
      ? children
      : ReactDOM.createPortal(
          <div className="search-modal">{children}</div>,
          modalRoot
        );
  }

  if (!isMobileModal) {
    return children;
  }
};
